module.exports = __webpack_public_path__ + "img/pro_two_7.8a7e9954.jpg";